/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { YearSpendingDto } from './YearSpendingDto';
import {
    YearSpendingDtoFromJSON,
    YearSpendingDtoFromJSONTyped,
    YearSpendingDtoToJSON,
    YearSpendingDtoToJSONTyped,
} from './YearSpendingDto';

/**
 * 
 * @export
 * @interface SpendingDto
 */
export interface SpendingDto {
    /**
     * 
     * @type {string}
     * @memberof SpendingDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpendingDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SpendingDto
     */
    totalSpending?: number;
    /**
     * 
     * @type {number}
     * @memberof SpendingDto
     */
    orderCount?: number;
    /**
     * 
     * @type {{ [key: string]: YearSpendingDto; }}
     * @memberof SpendingDto
     */
    spendingByYear?: { [key: string]: YearSpendingDto; } | null;
}

/**
 * Check if a given object implements the SpendingDto interface.
 */
export function instanceOfSpendingDto(value: object): value is SpendingDto {
    return true;
}

export function SpendingDtoFromJSON(json: any): SpendingDto {
    return SpendingDtoFromJSONTyped(json, false);
}

export function SpendingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpendingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'totalSpending': json['totalSpending'] == null ? undefined : json['totalSpending'],
        'orderCount': json['orderCount'] == null ? undefined : json['orderCount'],
        'spendingByYear': json['spendingByYear'] == null ? undefined : (mapValues(json['spendingByYear'], YearSpendingDtoFromJSON)),
    };
}

export function SpendingDtoToJSON(json: any): SpendingDto {
    return SpendingDtoToJSONTyped(json, false);
}

export function SpendingDtoToJSONTyped(value?: SpendingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'totalSpending': value['totalSpending'],
        'orderCount': value['orderCount'],
        'spendingByYear': value['spendingByYear'] == null ? undefined : (mapValues(value['spendingByYear'], YearSpendingDtoToJSON)),
    };
}

